import { IconButton } from '@mui/material'

import helpIcon from '../../images/help-icon.svg'

import useStyles from './index.styles'

interface IProps {
  url: string
}

const HelpIconUrl = (props: IProps) => {
  const { url } = props

  const classes = useStyles

  return (
    <IconButton component="a" href={url} target="_blank" rel="noopener noreferrer" aria-label="Help">
      <img src={helpIcon} alt="Help" style={classes.icon} />
    </IconButton>
  )
}

export default HelpIconUrl
